import { useUserInfo } from "@next-platform/client-common-core";

import { Row, Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES, SPICYCHAT_USER_PERMISSIONS } from "@/constants";

const CappedMessagesNotice = () => {
  const { permissions } = useUserInfo();
  const isSubscriber = permissions?.includes(SPICYCHAT_USER_PERMISSIONS.skip_waiting_room);

  return (
    <Row justify="center" className="text-center rounded-lg border-white">
      <div className="text-wrap p-2 mb-2 border-2">
        <Text variant="xs" type="neutral">
          <Trans i18nKey="chat:cappedMessage.title" />
          {!isSubscriber && (
            <Trans
              i18nKey="chat:cappedMessage.subTitle"
              components={{ subscriberLink: <LocalizedLink to={ROUTES.subscribe} className="underline" /> }}
            />
          )}
        </Text>
      </div>
    </Row>
  );
};

export default CappedMessagesNotice;
